import { LBButton } from '@linearb/buzz';
import CopilotEmptyStateImage from './images/copilot-empty-state.svg';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import { REPORT_IDS } from 'views/root/views/home/views/performance/views/CustomReport/consts';
import { useHistory } from 'react-router';
import AppRouter from 'common/AppRouter';

const CopilotDashboardCTA = () => {
  const history = useHistory();
  return (
    <div className='flex rounded-md border border-gray-300 px-10 py-20'>
      <div className='flex flex-1 flex-col justify-center'>
        <h1 className='mb-4 text-4xl font-semibold leading-tight'>
          Start tracking
          <br />
          Copilot metrics
        </h1>
        <div className='space-y-2'>
          <p className='text-base text-gray-600'>
            See how AI is contributing to your pull requests, <br /> commits,
            and reviews.
          </p>
          <div className='w-20 pt-4'>
            <LBButton
              onClick={() => {
                TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                  page: TRACKING.PAGES.METRICS,
                  dashboard_name: REPORT_IDS.AI_GITHUB_COPILOT,
                  click_type: TRACKING.CLICK.ENABLE_COPILOT_DASHBOARD_CTA
                });

                history.push(
                  AppRouter.AI_INTEGRATIONS_SETTINGS.GITHUB_COPILOT.path
                );
              }}
            >
              Enable Copilot tracking
            </LBButton>
          </div>
          <div className='text-xs text-gray-500'>
            (Admin rights required to enable tracking)
          </div>
        </div>
      </div>

      <div className='flex flex-1 items-center justify-start'>
        <img
          src={CopilotEmptyStateImage}
          alt='Copilot Dashboard Empty State Illustration'
          className='size-full'
        />
      </div>
    </div>
  );
};

export default CopilotDashboardCTA;
